import { render, staticRenderFns } from "./ListTaxPage.vue?vue&type=template&id=26416e8c&"
import script from "./ListTaxPage.vue?vue&type=script&lang=js&"
export * from "./ListTaxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports